import script from "./InstructionsButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstructionsButton.vue?vue&type=script&setup=true&lang=ts"

import "./InstructionsButton.vue?vue&type=style&index=0&id=1010dc3c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1010dc3c"]])

export default __exports__